/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Epicgamesstore2Inputs */

const id_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ms_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const da_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const de_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const en_us2_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const es_es2_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const es_mx2_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fil_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fr_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const it_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const hu_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const nl_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const no_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pl_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pt_br2_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const pt_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ro_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const fi_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const sv_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const vi_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const tr_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const cs_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const bg_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ru_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const uk_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ar_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const hi_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const th_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const ja_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

const zh_cn2_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城`)
};

const zh_hant1_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城`)
};

const ko_profile_hero_epicgamesstore2 = /** @type {(inputs: Profile_Hero_Epicgamesstore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store`)
};

/**
* | output |
* | --- |
* | "Epic Games Store" |
*
* @param {Profile_Hero_Epicgamesstore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_epicgamesstore2 = /** @type {((inputs?: Profile_Hero_Epicgamesstore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Epicgamesstore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_epicgamesstore2(inputs)
	if (locale === "ms") return ms_profile_hero_epicgamesstore2(inputs)
	if (locale === "da") return da_profile_hero_epicgamesstore2(inputs)
	if (locale === "de") return de_profile_hero_epicgamesstore2(inputs)
	if (locale === "en-US") return en_us2_profile_hero_epicgamesstore2(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_epicgamesstore2(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_epicgamesstore2(inputs)
	if (locale === "fil") return fil_profile_hero_epicgamesstore2(inputs)
	if (locale === "fr") return fr_profile_hero_epicgamesstore2(inputs)
	if (locale === "it") return it_profile_hero_epicgamesstore2(inputs)
	if (locale === "hu") return hu_profile_hero_epicgamesstore2(inputs)
	if (locale === "nl") return nl_profile_hero_epicgamesstore2(inputs)
	if (locale === "no") return no_profile_hero_epicgamesstore2(inputs)
	if (locale === "pl") return pl_profile_hero_epicgamesstore2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_epicgamesstore2(inputs)
	if (locale === "pt") return pt_profile_hero_epicgamesstore2(inputs)
	if (locale === "ro") return ro_profile_hero_epicgamesstore2(inputs)
	if (locale === "fi") return fi_profile_hero_epicgamesstore2(inputs)
	if (locale === "sv") return sv_profile_hero_epicgamesstore2(inputs)
	if (locale === "vi") return vi_profile_hero_epicgamesstore2(inputs)
	if (locale === "tr") return tr_profile_hero_epicgamesstore2(inputs)
	if (locale === "cs") return cs_profile_hero_epicgamesstore2(inputs)
	if (locale === "bg") return bg_profile_hero_epicgamesstore2(inputs)
	if (locale === "ru") return ru_profile_hero_epicgamesstore2(inputs)
	if (locale === "uk") return uk_profile_hero_epicgamesstore2(inputs)
	if (locale === "ar") return ar_profile_hero_epicgamesstore2(inputs)
	if (locale === "hi") return hi_profile_hero_epicgamesstore2(inputs)
	if (locale === "th") return th_profile_hero_epicgamesstore2(inputs)
	if (locale === "ja") return ja_profile_hero_epicgamesstore2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_epicgamesstore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_epicgamesstore2(inputs)
	return ko_profile_hero_epicgamesstore2(inputs)
});
export { profile_hero_epicgamesstore2 as "profile.hero.epicGamesStore" }